export default "__VITE_ASSET__ozNOkPYY__"